<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar
      @goOnePage="butsIndex = 0"
      :goodsNumber="goodsNumber"
      :tabbarIndex="1"
      :tabbarInfoShow="false"
    ></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
	<div class="df-maina-ddtit"><span>{{btns[butsIndex].name}}</span></div>
    <div class="df-maina">
		<div class="df-spzx-da">
			<div
				:ref="'btn' + index"
				:class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
				@click="clickedBtns(index)"
				v-for="(item, index) of btns"
				:key="index"
			>
				<div class="df-spzx-dam">{{ item.name }}</div>
				<div class="df-spzx-daico"></div>
			</div>
		</div>
		
        <!--<div class="left">
          <div class="bottom">
            <div
              :ref="'btn' + index"
              :class="index == butsIndex ? 'hands item item-on' : 'hands item'"
              @click="clickedBtns(index)"
              v-for="(item, index) of btns"
              :key="index"
            >
              <div class="left oneLine">{{ item.name }}</div>
              <div v-if="index == butsIndex" class="right rightright"></div>
            </div>
          </div>
        </div>-->

		<div class="df-mainar">
        <!-- 订单中心->导入订单(多商品)-->
        <into-order-much :obj="obj"
          @reset="reset"
          v-if="btns[butsIndex].name == '导入订单'"
        ></into-order-much>
        <!-- 订单中心->导入订单(多商品)-->

        <!-- 订单中心->导入订单(单商品) -->
        <into-order-less :obj="obj"
          @reset="reset"
          v-else-if="btns[butsIndex].name == '导入订单(单商品)'"
        ></into-order-less>
        <!-- 订单中心->导入订单(单商品) -->

        <!-- 订单中心->已导入订单 -->
        <intoed-order :obj="obj"
          v-else-if="btns[butsIndex].name == '已导入订单'"
        ></intoed-order>
        <!-- 订单中心->已导入订单 -->

        <!-- 订单中心->发货中订单 -->
        <sending-goods :obj="obj"
          v-else-if="btns[butsIndex].name == '发货中订单'"
        ></sending-goods>
        <!-- 订单中心->发货中订单 -->

        <!-- 订单中心->已发货订单 -->
        <sent-order :obj="obj"
          v-else-if="btns[butsIndex].name == '已发货订单'"
        ></sent-order>
        <!-- 订单中心->已发货订单 -->

        <!-- 订单中心->全部订单 -->
        <all-order :obj="obj" v-else-if="btns[butsIndex].name == '全部订单'"></all-order>
        <!-- 订单中心->全部订单 -->

        <!-- 订单中心->未支付订单 -->
        <unpaid-order :obj="obj" v-else-if="btns[butsIndex].name == '未支付订单'"></unpaid-order>
        <!-- 订单中心->未支付订单 -->

        <!-- 订单中心->售后订单 -->
        <saled-order :obj="obj"
          v-else-if="btns[butsIndex].name == '售后订单'"
        ></saled-order>
        <!-- 订单中心->售后订单 -->

        <!-- 订单中心->退货订单 -->
        <return-order :obj="obj"
          v-else-if="btns[butsIndex].name == '退货订单'"
        ></return-order>
        <!-- 订单中心->退货订单 -->
		</div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import intoOrderMuch from "./components/intoOrderMuch";
import intoOrderLess from "./components/intoOrderLess";
import intoedOrder from "./components/intoedOrder";
import sendingGoods from "./components/sendingGoods";
import sentOrder from "./components/sentOrder";
import allOrder from "./components/allOrder";
import saledOrder from "./components/saledOrder";
import unpaidOrder from "./components/unpaidOrder";

import returnOrder from "./components/returnOrder";
import {
  getUserBaseInfoRequest,
  shoppingCarNumber,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      btns: [
        // 1.1.buttons
        { name: "导入订单", id: 1 },
        // { name: "导入订单(单商品)", id: 2 },
        { name: "已导入订单", id: 3 },
        { name: "发货中订单", id: 4 },
        { name: "已发货订单", id: 5 },
        { name: "全部订单", id: 6 },
        { name: "未支付订单", id: 8 },
        { name: "售后订单", id: 7 },
        { name: "退货订单", id: 8 },
      ],
      obj: {},
      butsIndex: 0, // 1.2.当前激活按钮
      goodsNumber: 0, // 1.3.购物车商品数量
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.页面顶部部分
    cFooter: footer, // 2.2.页面底部
    intoOrderMuch, // 2.4.右侧下部分导入订单多
    intoOrderLess, // 2.4.右侧下部分导入订单单
    intoedOrder, // 2.5.右侧下部分已导入订单
    sendingGoods, // 2.6.右侧下部分发货中订单
    sentOrder, // 2.7.右侧下部分已发货订单
    allOrder, // 2.8.右侧下部分全部订单
    saledOrder, // 2.9.右侧下部分售后订单
    unpaidOrder, // 2.9.右侧下部分未支付订单
    returnOrder,//退货订单
  },

  methods: {
    // 3.methods
    clickedBtns(index) {
      // 3.1.按钮回调
      if (this.butsIndex != index) {
        this.butsIndex = index;
        this.obj = this.btns[index];
        localStorage.orderButtonIndex = this.butsIndex;
      }
    },

    reset(target) {
      // 3.2.重置导入信息
      this.$refs["btn6"][0].click();
      this.butsIndex = 6;
      setTimeout(
        function() {
          this.$refs["btn" + target][0].click();
          this.butsIndex = target;
        }.bind(this),
        10
      );
    },

    getGoodsNumber() {
      // 3.3.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    getUserInfo() {
      // 3.4.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
      this.getUserInfo();
    }
    if (localStorage.orderButtonIndex) {
      this.butsIndex = localStorage.orderButtonIndex;
    } else {
      if (this.$route.query.buttonIndex) {
        this.butsIndex = this.$route.query.buttonIndex;
      } else {
        if (localStorage.orderButtonIndex) {
          this.butsIndex = localStorage.orderButtonIndex;
        } else {
          this.butsIndex = 0;
        }
      }
    }
  },
};
</script>
